import React, { useState } from 'react'
import { useHover } from 'react-use'
import classNames from 'classnames'
import Tooltip from '../Tooltip/Tooltip'
import Info from '../Svgs/Info'
import styles from './Switch.module.scss'

type TProps = {
  className?: string
  label?: string
  labelHint?: string
  id?: string
  name?: string
  checked: boolean
  error?: string
  disabled?: boolean
  onChange: (e: any) => void
}

const Switch = ({
  className,
  label,
  labelHint,
  id,
  name,
  checked,
  error,
  disabled,
  onChange,
}: TProps): React.ReactElement => {
  const [focused, setFocused] = useState(false)
  const inputId = id || name

  const classes = classNames([styles.root, className], {
    [styles['is-focused']]: focused,
    [styles['is-checked']]: checked,
    [styles['has-error']]: error,
    [styles['is-disabled']]: disabled,
  })

  const handleChange = (e: any): void => {
    onChange({ ...e, checked: !checked })
  }

  const toggleFocus = (): void => setFocused(!focused)

  const [hoverableInfoIcon, isHovering] = useHover(
    <div className={styles['info-icon']}>
      <Info width={20} height={20} />
    </div>,
  )

  return (
    <div className={classes}>
      {label && (
        <label htmlFor={inputId}>
          {labelHint && (
            <Tooltip isOpen={isHovering} body={labelHint}>
              {hoverableInfoIcon}
            </Tooltip>
          )}
          <input
            id={inputId}
            disabled={disabled}
            name={name}
            type="checkbox"
            checked={checked}
            onChange={handleChange}
            onFocus={toggleFocus}
            onBlur={toggleFocus}
          />
          <strong>{label}</strong>
          <span>
            <span>Off</span>
            <span>On</span>
            <button disabled={disabled} type="button" onClick={handleChange} />
          </span>
          {error && ` - ${error as string}`}
        </label>
      )}
    </div>
  )
}

export default Switch
